import {
  CampaignType,
  Channels,
  CustomTemplatedMessageVariables
} from 'generated-graphql/types';

type GetSourcingSharedDefaultOutreachTemplatedWithEndingMessageControllerInput =
  {
    campaignType: CampaignType;
    startingMessage: string;
    channelType: Channels;
  };

export const JOB_URL_ENDING_MESSAGE = `Based on what I could find online, your experience looks like a perfect fit for this role. If this sounds interesting, could you apply to the role at {{${CustomTemplatedMessageVariables.JobApplicationUrl}}} so that the team can give your experience a deeper look and reach out to schedule some time if appropriate?\n\nLet me know if you have any questions\n\nBest regards,\n{{${CustomTemplatedMessageVariables.AgentName}}}`;
export const CV_ENDING_MESSAGE = `Based on what I could find online, your experience looks like a perfect fit for this role. If this sounds interesting, could you reply with your CV so that the team can give your experience a deeper look and reach out to schedule some time if appropriate?\n\nLet me know if you have any questions\n\nBest regards,\n{{${CustomTemplatedMessageVariables.AgentName}}}`;

export const getSourcingSharedDefaultOutreachTemplatedWithEndingMessageController =
  (
    input: GetSourcingSharedDefaultOutreachTemplatedWithEndingMessageControllerInput
  ) => {
    if (input.channelType === Channels.Sms) {
      return `${input.startingMessage}\n\n{{${CustomTemplatedMessageVariables.AgentName}}}`;
    }

    switch (input.campaignType) {
      case CampaignType.CustomJobApplicationUrlOutreach:
      case CampaignType.AtsJobApplicationUrlOutreach:
        return `${input.startingMessage}\n\n${JOB_URL_ENDING_MESSAGE}`;
      case CampaignType.RequestCvOutreach:
        return `${input.startingMessage}\n\n${CV_ENDING_MESSAGE}`;
      default:
        return input.startingMessage;
    }
  };
